import { forwardRef } from "react";
import { cn } from "@/lib/utils";

export const RcButton = forwardRef(function RcButton(
  { className, variant = "primary", children, ...props }, ref
) {
  const base =
    "inline-flex items-center justify-center gap-2 px-6 py-3 text-sm tracking-wider uppercase " +
    "transition-all duration-300 font-medium select-none disabled:opacity-50 disabled:cursor-not-allowed";
  const variants = {
    primary:
      "bg-[#CFA05E] text-[#120D0C] hover:bg-[#E6B875] hover:-translate-y-0.5 hover:shadow-[0_10px_30px_-12px_rgba(207,160,94,0.6)]",
    outline:
      "border border-[#362B28] text-[#FDFBF7] hover:border-[#CFA05E] hover:text-[#CFA05E]",
    ghost:
      "text-[#A39E93] hover:text-[#FDFBF7]",
  };
  return (
    <button ref={ref} className={cn(base, variants[variant], className)} {...props}>
      {children}
    </button>
  );
});
